/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createOrUpdateTimecard} from '../api'

export const useMutationCreateOrUpdateTimecard = createReactQueryMutationHook('createOrUpdateTimecard', createOrUpdateTimecard)
